import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const Width = ({ width }: SpecProps<"width">) => {
  const { i18n } = useLingui();

  if (width == null) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.width",
    message: "Width",
    comment: "Field for 'width' in ad specification",
  });
  const value = i18n.t({
    id: "itemPageLayout.keyInfo.width.value",
    message: "{width} cm",
    comment: "Field for 'width' in ad specification",
    values: { width: width },
  });

  return <FieldValuePair field={field} value={value} />;
};
